<mat-form-field
  appearance="outline"
  floatLabel="always"
  class="q9-form-field q9-full-width q9-labeled-field gpt-message-control">
  <mat-label>{{ 'AI_CHAT.QUESTION_LABEL' | translate }}</mat-label>

  <textarea
    matInput
    q9Trim
    class="text-input"
    [placeholder]="'Ask your question' | translate"
    [formControl]="control"
    (keydown.meta.enter)="processMessage()"
    rows="2"></textarea>

  <mat-hint align="end">Ctrl/Cmd + Enter</mat-hint>

  <mat-error>{{ 'AI_CHAT.MESSAGE_LENGTH_ERROR' | translate }}</mat-error>

  <q9-icon-button
    icon="send-message"
    q9Track="AI_CHAT.SEND_BUTTON"
    [isLoading]="loading()"
    [disabled]="control.invalid || loading()"
    (click)="processMessage()"></q9-icon-button>
</mat-form-field>
